var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35924 2.64076L5.58579 1.41421C6.36683 0.633165 7.63316 0.633164 8.41421 1.41421L13.5858 6.58579C14.3668 7.36684 14.3668 8.63317 13.5858 9.41421L10.001 12.999C9.4032 13.5968 9.255 14.51 9.63307 15.2661C11.8186 19.6372 15.3628 23.1814 19.7339 25.3669C20.49 25.745 21.4032 25.5968 22.001 24.999L25.5858 21.4142C26.3668 20.6332 27.6332 20.6332 28.4142 21.4142L33.5858 26.5858C34.3668 27.3668 34.3668 28.6332 33.5858 29.4142L32.3592 30.6408C28.1365 34.8635 21.4514 35.3386 16.674 31.7555L14.2571 29.9429C10.7701 27.3276 7.67244 24.2299 5.05714 20.7429L3.24453 18.326C-0.338556 13.5486 0.136537 6.86346 4.35924 2.64076Z",
    fill: "#FF0050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingPhone);
export default __webpack_public_path__ + "static/media/SettingPhone.b74226908c48dd099e5325aa30289382.svg";
export { ForwardRef as ReactComponent };